// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setManageShareListModalIsOpen from "@insite/client-framework/Store/Components/ManageShareListModal/Handlers/SetManageShareListModalIsOpen";
import setShareListDetailModalIsOpen from "@insite/client-framework/Store/Components/ShareListDetailModal/Handlers/SetShareListDetailModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import Lock from "@insite/mobius/Icons/Lock";
import Users from "@insite/mobius/Icons/Users";
import Link from "@insite/mobius/Link";
// import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip"; // Starter Custom Code
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

interface OwnProps {
    extendedStyles?: WishListSharingStatusStyles;
    /**
     * @deprecated Use the `wishList` property instead.
     */
    isSharedList?: boolean;
    /**
     * @deprecated Use the `wishList` property instead.
     */
    wishListSharesCount?: number;
    /**
     * @deprecated Use the `wishList` property instead.
     */
    sharedByDisplayName?: string;
    wishList?: WishListModel;
    showNoPermissionsTooltip?: boolean;
    /* Foundation */
    removeTooltip?: boolean;
}

const mapDispatchToProps = {
    setManageShareListModalIsOpen,
    setShareListDetailModalIsOpen,
};

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
});

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface WishListSharingStatusStyles {
    statusText?: TypographyProps;
    privateIcon?: IconPresentationProps;
    sharedIcon?: IconPresentationProps;
    privateTooltip?: TooltipPresentationProps;
    autogeneratedIcon?: IconPresentationProps;
    autogeneratedTooltip?: TooltipPresentationProps;
    // Starter Custom Code
    privateText?: TypographyProps;
}

export const wishListSharingStatusStyles: WishListSharingStatusStyles = {
    privateText: {
        css: css`
            display: flex !important; /* important to bypass ellipsis display from table */
            align-items: center;
        `,
    },
    privateTooltip: {
        cssOverrides: {
            tooltipContainer: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipContainer}
                width: ${pxToRem(250)};
            `,
        },
    },
    // Foundation --->
    privateIcon: {
        src: HelpCircle,
        size: 15,
        css: css`
            margin-left: ${pxToRem(5)};
        `,
    },
    sharedIcon: {
        src: Users,
        size: 15,
        css: css`
            margin-right: ${pxToRem(5)};
        `,
    },
    // <--- Foundation
};

const WishListSharingStatus: FC<Props> = ({
    extendedStyles,
    isSharedList,
    wishListSharesCount,
    sharedByDisplayName,
    wishList,
    setManageShareListModalIsOpen,
    setShareListDetailModalIsOpen,
    wishListSettings,
    showNoPermissionsTooltip,
    // Foundation
    removeTooltip,
}) => {
    const styles = useMergeProps(wishListSharingStatusStyles, extendedStyles); // Starter Custom Code

    if (!wishList || !wishListSettings?.allowMultipleWishLists || !wishListSettings?.allowListSharing) {
        return null;
    }

    const manageShareListClickHandler = () => {
        setManageShareListModalIsOpen({ modalIsOpen: true, wishListId: wishList.id });
    };

    const shareListDetailClickHandler = () => {
        setShareListDetailModalIsOpen({ modalIsOpen: true, listOwner: wishList?.sharedByDisplayName });
    };

    const isSharedListInner = isSharedList || wishList.isSharedList || false;
    const wishListSharesCountInner = wishListSharesCount || wishList.wishListSharesCount || 0;
    const sharedByDisplayNameInner = sharedByDisplayName || wishList.sharedByDisplayName;

    if (wishList.isAutogenerated) {
        return (
            <Typography {...styles.privateText /* Starter Custom Code */} data-test-selector="myLists_autogenerated">
                {/* Starter Removed - autogeneratedIcon */}
                {translate("Auto-generated")}
                <Tooltip
                    {...styles.privateTooltip}
                    text={siteMessage("Lists_Autogenerated_List_Tooltip") as string}
                    // Starter Custom Code
                    clickableTitle={translate("Open tooltip for more information")}
                    triggerAltText={translate("Open tooltip for more information")}
                />
            </Typography>
        );
    }

    const othersText = wishListSharesCountInner === 1 ? translate("other") : translate("others"); // Starter Custom Code

    return (
        <>
            {!isSharedListInner && wishList.shareOption === "Private" && (
                <Typography {...styles.privateText} data-test-selector="myLists_PrivateLabel" /* Starter Custom Code */>
                    {translate("Private")}
                    {/* Foundation ---> */}
                    {!removeTooltip && (
                        <Tooltip {...styles.privateTooltip} text={siteMessage("Lists_Share_List_Tooltip") as string} />
                    )}
                    {/* <--- Foundation */}
                </Typography>
            )}
            {!isSharedListInner && wishList.shareOption !== "Private" && (
                <>
                    <Link
                        {...styles.statusText}
                        onClick={() => manageShareListClickHandler()}
                        data-test-selector="shareWithOthers"
                    >
                        {/* Starter Removed - sharedIcon */}
                        {translate("Shared with")} {wishListSharesCountInner} {othersText /* Starter Custom Code */}
                    </Link>
                </>
            )}
            {isSharedListInner && sharedByDisplayNameInner && (
                <Typography {...styles.statusText} data-test-selector="myLists_listSharedBy">
                    <Link
                        {...styles.statusText}
                        onClick={() => shareListDetailClickHandler()}
                        data-test-selector="sharedBy"
                    >
                        {/* Starter Removed - sharedIcon */}
                        {translate("Shared by")} {sharedByDisplayNameInner}
                    </Link>
                    {!wishList?.allowEdit && showNoPermissionsTooltip && (
                        <Tooltip
                            {...styles.privateTooltip}
                            text={siteMessage("Lists_Share_List_No_Permissions_Tooltip") as string}
                        />
                    )}
                </Typography>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(WishListSharingStatus);
